import React from "react";
import clsx from "clsx";
import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { Hash, Lock, MessageSquare, Users } from "lucide-react";
import {
  ChatSyncSelectionTypes,
  LinkedAccountChatFilter,
} from "../../../../../../../../models/Entities";
import { NAME_COLUMN_CLASS, TYPE_COLUMN_CLASS } from "../constants";
import UpdatedCell from "./UpdatedCell";
import EmptyCellValue from "./EmptyCellValue";

interface Props {
  selection: LinkedAccountChatFilter;
}

const getDisplayType = (displayType: string | undefined, isGroup: boolean, isTeam: boolean) => {
  if (!displayType) return isGroup ? "Team" : undefined;
  if (isTeam || isGroup) return displayType;
  return `${displayType}_CHANNEL`;
};

const getIcon = (isGroupOrTeam: boolean, displayType: string | undefined) => {
  if (isGroupOrTeam) return Users;
  if (displayType?.includes("PUBLIC")) return Hash;
  if (displayType?.includes("PRIVATE")) return Lock;
  return MessageSquare;
};

const ChatSyncSelectionRow = ({ selection }: Props) => {
  // derived state
  const isGroup = selection.type?.toLowerCase() === ChatSyncSelectionTypes.CHAT_GROUP.toLowerCase();
  const isTeam = selection.display_type === "TEAM";
  const displayType = getDisplayType(selection.display_type, isGroup, isTeam);
  const Icon = getIcon(isGroup || isTeam, selection.display_type);

  // render
  return (
    <>
      {/* Name cell contains customer-tenant content and is thus masked at the cell */}
      <div role="cell" title={selection.name} className={clsx(NAME_COLUMN_CLASS, "ph-no-capture")}>
        <Icon size={16} className="shrink-0 text-gray-40" />
        <Text className="min-w-0 truncate">{selection.name}</Text>
      </div>
      <div role="cell" className={TYPE_COLUMN_CLASS}>
        {displayType ? (
          <Badge color={isGroup || isTeam ? "gray" : "blue"}>{displayType}</Badge>
        ) : (
          <EmptyCellValue />
        )}
      </div>
      <UpdatedCell updatedAt={selection.updated_at} />
    </>
  );
};

export default ChatSyncSelectionRow;
